import { render, staticRenderFns } from "./BlockVerifiedProperties.vue?vue&type=template&id=737040c0&scoped=true&"
import script from "./BlockVerifiedProperties.vue?vue&type=script&lang=js&"
export * from "./BlockVerifiedProperties.vue?vue&type=script&lang=js&"
import style0 from "./BlockVerifiedProperties.vue?vue&type=style&index=0&id=737040c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737040c0",
  null
  
)

export default component.exports